import axios from 'axios';
import { BrowserRouter as Router } from 'react-router';
import { Toaster } from 'sonner';
import { DataProvider } from './contexts/data-context/data-provider';
import { ErrorBoundary } from './contexts/error-boundary/error-boundary';
import { FeatureFlagProvider } from './contexts/feature-flag-context/feature-flag';
import { SSEProvider } from './contexts/sse-context/sse-provider';
import { SwrProvider } from './contexts/swr-provider';
import { UserInfoProvider } from './contexts/user-context/user-info-provider';
import { UserProvider } from './contexts/user-context/user-provider';
import { AppRoutes } from './routes/app-routes';

export const App = () => {
  axios.defaults.timeout = 30000; // 30 seconds
  return (
    <Router>
      <ErrorBoundary>
        <SwrProvider>
          <FeatureFlagProvider>
            <UserInfoProvider>
              <SSEProvider>
                <UserProvider>
                  <DataProvider>
                    <AppRoutes />

                    {/* https://sonner.emilkowal.ski/toaster */}
                    <Toaster
                      toastOptions={{
                        classNames: {
                          toast: 'bg-seapoint-gray-medium rounded-lg border-2 border-seapoint-yellow',
                          title: 'text-black',
                          error: 'text-red-500',
                          success: 'text-seapoint-green',
                        },
                      }}
                    />
                  </DataProvider>
                </UserProvider>
              </SSEProvider>
            </UserInfoProvider>
          </FeatureFlagProvider>
        </SwrProvider>
      </ErrorBoundary>
    </Router>
  );
};
